import Box, { type BoxProps } from '@mui/material/Box'
import React from 'react'

type CommonTextLabelProps = BoxProps & {
  title?: string | null
  isRequired?: boolean
}

const CommonTextLabel: React.FC<CommonTextLabelProps> = ({
  children,
  title = null,
  className = '',
  isRequired = false,
  onClick,
  sx,
  ...rest
}) => (
  <Box className={`common label ${className}`} component="label" htmlFor={title ?? undefined} sx={sx} onClick={onClick} {...rest}>
    {title || children}
    {isRequired && (
      <Box className="red" component="span" ml={0.5}>
        *
      </Box>
    )}
  </Box>
)

export default CommonTextLabel
